import { render, staticRenderFns } from "./DialogCardBaseNew.vue?vue&type=template&id=5b1275ae"
import script from "./DialogCardBaseNew.vue?vue&type=script&lang=js"
export * from "./DialogCardBaseNew.vue?vue&type=script&lang=js"
import style0 from "./DialogCardBaseNew.vue?vue&type=style&index=0&id=5b1275ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports